export const ResetPWIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.58325 6.5C10.4108 6.5 12.8158 8.30917 13.7041 10.8333H24.9166V15.1667H22.7499V19.5H18.4166V15.1667H13.7041C12.8158 17.6908 10.4108 19.5 7.58325 19.5C3.99742 19.5 1.08325 16.5858 1.08325 13C1.08325 9.41417 3.99742 6.5 7.58325 6.5ZM5.41658 13C5.41658 14.1917 6.39158 15.1667 7.58325 15.1667C8.77492 15.1667 9.74992 14.1917 9.74992 13C9.74992 11.8083 8.77492 10.8333 7.58325 10.8333C6.39158 10.8333 5.41658 11.8083 5.41658 13Z"
        fill="#1181E8"
      />
    </svg>
  );
};

export default ResetPWIcon;
